import { useNavigate } from 'react-router-dom';

import Text from '@/shared-components/text/components/Text';

import './styles/NavbarHomeNavigation.css';

export default function NavbarHomeNavigation({ active }) {
  const navigate = useNavigate();
  return (
    <>
      <div className="navbar-home-navigation__links element-non-selectable">
        <div
          className={`navbar-home-navigation__link ${active === "home" ? "active" : ""}`}
          onClick={() => navigate("/", { replace: true, end: true })}
        >
          <Text className="navbar-home-navigation__link-text font-size-medium">Home</Text>
        </div>
        
        <div
          className={`navbar-home-navigation__link ${active === "community" ? "active" : ""}`}
          onClick={() => navigate("/community", { replace: true })}
        >
          <Text className="navbar-home-navigation__link-text font-size-medium">Community</Text>
        </div>
      </div>
    </>
  );
}
